export const DATADOG_CONFIG = {
  applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID ?? '',
  clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ?? '',
  site: process.env.NEXT_PUBLIC_DATADOG_SITE ?? 'datadoghq.com',
  service: process.env.NEXT_PUBLIC_DATADOG_SERVICE ?? 'web-service-v2',
  env: process.env.NEXT_PUBLIC_DATADOG_ENV ?? 'development',
  // 배포 파이프라인 build-arg로 주입되는 릴리즈 태그(prod: v1.26.4) 또는 브랜치명(develop/stage).
  // 미주입 빌드·로컬에서는 빈 문자열/undefined라 'local'로 폴백한다.
  version: process.env.NEXT_PUBLIC_APP_VERSION || 'local',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 0,
  startSessionReplayRecordingManually: true,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input' as const,
} as const
